
export type ColumnUid = string;

export interface ColItemsHandler<ItemData, ColumnData> {
    /** get col items with colData if available in call context */
    getColumnItems(columnUid: ColumnUid, columnData: ColumnData | undefined): ItemData[];
    /** add col item to col cache with colData if available in call context */
    addItemToColCache(columnUid: ColumnUid, item: ItemData, columnData: ColumnData | undefined): void;
    /** remove col item from col cache with colData if available in call context */
    removeItemFromColumnCache(columnUid: ColumnUid, item: ItemData, columnData: ColumnData | undefined): void;
}


export const DEFAULT_DAY_AGENDA_ROW_HEIGHT = 50;


/**
 * day: one day view
 * week: one week view
 */
export type DayAgendaMode = "day" | "week";
